export default __webpack_public_path__ + "static/media/en.520d4b08.svg";